import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/malebranche1698.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>Die philophischen schriften von Gottfried Wilheim Leibniz, vol. I</var><br />
		C. I. Gerhardt (ed)<br />
		p 354<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 2/12 October 1698<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (12k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Nicolas Malebranche (2/12 October 1698)</title>
            <meta name="description" content="An English translation of A LETTER TO NICOLAS MALEBRANCHE by Gottfried Wilhelm Leibniz, from 2/12 October 1698" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO NICOLAS MALEBRANCHE</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
             	[<b>G I p354</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;As Father Torelli has informed me that he has the honour to know you, I did not want him to leave here without carrying to you tokens which would let you know how much I continue to hold you in high regard. I have often given you others, even though I admitted that we were not always of the same opinion. We both have such a great interest in advancing the knowledge of the truth that we will always be at ease with the clarifications that one can give to the other or to the public. I have received the obligation from you, which you certainly wanted me to accept, when you made alterations to your laws of motion, and although in my opinion the law of continuity, which I had previously put forward in the Journal of Holland,<a name="1" href="#note1"><sup>1</sup></a> and which must have pleased you to the extent that it inspired you to make changes, is still somewhat required there, although in a less perceptible way than originally, nevertheless I believed that it would not be very graceful of me to insist upon it in front of you, being able to explain myself without that. For I believe in fact that the laws of nature are not so arbitrary as is often imagined. Everything is determined in things, either by reasons like the geometrical ones of necessity, or by reasons like the moral ones of the greatest perfection. Your wonderful writings, my reverend Father, have made men much more capable than they previously were of entering into profound truths; if I claim to benefit from it, I will not fail to recognize it as well. Mr Bayle has made objections to my system in his wonderful <var>Dictionary</var> in the article 'Rorarius'. Mr de Beauval will publish my solutions in the <var>Histoire des Ouvrages des Savants</var>, after having passed them on to Mr Bayle, who has written to me a very obliging letter about it, in which he recognizes the strength of my reply. I will not fail to ask him to make me aware if there is anything which he still objects to. And nothing is more agreeable to me than having the opportunity to be instructed by people who are as profound and as enlightened as are you and he. I am sincerely etc.
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTE:<br /><br />
                <a name="note1" href="#1">1.</a> 'On a general principle useful in explaining the laws of nature through a consideration of the divine wisdom, to serve as a reply to Father Malebranche's response' (<var>Nouvelles de la R&#233;publique des Lettres</var>, July 1687). English translation in SLT 131-134.<br /><br /><br />
                &#169; Lloyd Strickland 2004<br />
                With thanks to Geert de Wilde
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
